module.exports = __webpack_public_path__ + "static/media/delete.396fad88.svg";